import React from "react";
import { Helmet } from "react-helmet";
import TaxiServiceData from "../taxiService/TaxiServiceData";
import { useNavigate } from "react-router-dom";

export const CityCafe = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>The Best Cab Jaipur – Affordable Taxi, One Way & Outstation Services</title>
        <meta
          name="description"
          content="Book reliable and affordable cab services in Jaipur for one-way, round trips, and outstation travel. Explore Rajasthan’s top destinations with our trusted taxi service and tour packages."
        />
        <meta
          name="keywords"
          content="Jaipur cab service, one way taxi, round trip taxi, outstation travel, affordable taxi, Rajasthan tours, taxi booking Jaipur"
        />
        <meta name="author" content="The Best Cab Jaipur" />
      </Helmet>

      <section className="py-12 sm:py-16 lg:py-20 ">
        <div className="container mx-auto px-4 sm:px-8 lg:px-8">
          <div className="flex flex-col items-center mb-8 sm:mb-10 lg:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-gray-800 mb-3 sm:mb-4">
              Top Cities We Serve!
            </h2>
            <p className="text-gray-600 text-sm sm:text-base lg:text-lg text-center max-w-md">
              From Pink City to Metro Streets – We Drive You Everywhere!
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4 md:gap-5">
            {TaxiServiceData.slice(0, 10).map((taxiData, index) => (
              <div
                onClick={() => navigate(`/taxi-service/${taxiData.city.toLowerCase()}`,{ state: { taxiData } })}
                key={index}
                className="flex items-center justify-center bg-gray-200 rounded-lg shadow-sm hover:shadow-md hover:bg-pink-100 hover:border hover:border-pink-300 transition-all duration-200
              p-4 h-20 sm:h-24 md:h-28 w-full"
              >
                <p className="text-sm sm:text-xl md:text-lg font-medium text-gray-800 text-center">
                  {taxiData.city}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};
